import React from 'react';
import { Link } from 'react-router-dom';
import { footerLinks, contactInfo, brandLogoWhite } from '../mock';
import { Instagram, Facebook, Linkedin, Mail, Phone, MapPin, ArrowUpRight } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="relative pt-20 pb-32 md:pb-40 bg-[#0f2a1e] text-[#e9e4d3] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10 mb-14">
          <div className="sm:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <img src={brandLogoWhite} alt="Eduvantage Solutions" className="h-12 md:h-14 w-auto object-contain" />
            </Link>
            <p className="text-[#c9c2a8] text-[14px] leading-relaxed max-w-md font-body">
              India’s trusted training partner for US Taxation and Enrolled Agent (EA) certification. Learn from IRS-recognized faculty and get placed with Big 14 firms in 6 months.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[Instagram, Facebook, Linkedin].map((Icon, i) => (
                <a key={i} href="#" aria-label="social" className="w-9 h-9 rounded-full border border-[#f5f1e6]/20 flex items-center justify-center hover:bg-[#f5f1e6]/10 transition-colors">
                  <Icon size={15} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-body text-[#f5f1e6] text-sm font-semibold mb-4 tracking-wider uppercase">Courses</h4>
            <ul className="space-y-3">
              {footerLinks.services.map((l) => (
                <li key={l.name}>
                  <Link to={l.href} className="text-[#c9c2a8] hover:text-[#f5f1e6] text-[14px] font-body transition-colors">{l.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-body text-[#f5f1e6] text-sm font-semibold mb-4 tracking-wider uppercase">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((l) => (
                <li key={l.name}>
                  <Link to={l.href} className="text-[#c9c2a8] hover:text-[#f5f1e6] text-[14px] font-body transition-colors">{l.name}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-body text-[#f5f1e6] text-sm font-semibold mb-4 tracking-wider uppercase">Get in Touch</h4>
            <ul className="space-y-3 text-[14px] font-body text-[#c9c2a8]">
              <li className="flex items-start gap-2"><Mail size={14} className="mt-1" /> <a href={`mailto:${contactInfo.email}`} className="hover:text-[#f5f1e6]">{contactInfo.email}</a></li>
              <li className="flex items-start gap-2"><Phone size={14} className="mt-1" /> <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="hover:text-[#f5f1e6]">{contactInfo.phone}</a></li>
              <li className="flex items-start gap-2">
                <MapPin size={14} className="mt-1 shrink-0" />
                <div className="space-y-2">
                  {contactInfo.offices.map((office) => (
                    <div key={office.city} className="relative group w-fit">
                      <button type="button" className="text-left hover:text-[#f5f1e6] transition-colors underline decoration-[#f5f1e6]/20 underline-offset-4">
                        {office.city}
                      </button>
                      <div className="pointer-events-none absolute left-0 bottom-full z-20 mb-2 w-64 rounded-xl bg-[#f5f1e6] p-3 text-[12px] leading-relaxed text-[#143324] opacity-0 shadow-xl ring-1 ring-[#143324]/10 transition-opacity duration-200 group-hover:opacity-100">
                        {office.address}
                      </div>
                    </div>
                  ))}
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#f5f1e6]/10 pt-10">
          <div className="flex items-center justify-between flex-wrap gap-6">
            <img src={brandLogoWhite} alt="Eduvantage" className="h-16 md:h-24 lg:h-28 w-auto object-contain" />
            <Link to="/contact" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#f5f1e6] text-[#143324] text-sm font-body hover:bg-white transition-colors">
              Start Learning <ArrowUpRight size={16} />
            </Link>
          </div>
          <div className="mt-10 flex items-center justify-between flex-wrap gap-4 text-[12px] text-[#c9c2a8] font-body">
            <p>&copy; {new Date().getFullYear()} Eduvantage Solutions. All rights reserved.</p>
            <div className="flex items-center gap-6">
              <a href="#" className="hover:text-[#f5f1e6] transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-[#f5f1e6] transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
